/**
 * @constant {object} layerCombinations - Константа, определяющая способ идентификации объектов на карте
 */
let layersCombination = require('../../modules_constants/identify/layersCombination.json');

module.exports = {
  layersCombination: layersCombination
};